export default __webpack_public_path__ + "guideef69dd.png";